import { useEffect, useState } from "react";

/* eslint-disable import/no-anonymous-default-export */
export default (modalRef: React.RefObject<HTMLDivElement>) => {
  const [modalTop, setModalTop] = useState("50vh");

  // Nasłuchujemy komunikatów z rodzica
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (typeof event.data === "string" && event.data.startsWith("parentScrollInfo::")) {
        const parts = event.data.split("::");
        if (parts.length >= 3) {
          const parentScrollValue = parseFloat(parts[1]);
          const viewportHeight = parseFloat(parts[2]);
          const iframeTopPosition = parseFloat(parts[3]);
          const iframeBottomPosition = parseFloat(parts[4]);
          if (
            !isNaN(parentScrollValue) &&
            !isNaN(viewportHeight) &&
            !isNaN(iframeTopPosition) &&
            !isNaN(iframeBottomPosition)
          ) {
            updateModalPosition(parentScrollValue, viewportHeight, iframeTopPosition, iframeBottomPosition);
          }
        }
      }
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
    //eslint-disable-next-line
  }, []);

  const updateModalPosition = (
    parentScroll: number,
    viewportHeight: number,
    iframeTopPosition: number,
    iframeBottomPosition: number
  ) => {
    if (window.self !== window.top) {
      // Jesteśmy w iframe, używamy pozycji iframe
      if (modalRef && modalRef.current) {
        const modalHeight = modalRef.current.offsetHeight;
        // Naturalny środek modala względem rodzica, przeliczony na współrzędne iframe
        let candidate = parentScroll + viewportHeight / 2 - iframeTopPosition;

        const iframeHeight = iframeBottomPosition - iframeTopPosition;
        // Dolna granica – aby górna część modala nie wyszła poza iframe
        const lowerBound = modalHeight / 2;
        // Górna granica – aby dolna część modala była widoczna
        const upperBound = iframeHeight - modalHeight / 2;
        // Klamrujemy candidate do zakresu [lowerBound, upperBound]
        candidate = Math.min(Math.max(candidate, lowerBound), upperBound);

        setModalTop(`${candidate}px`);
      } else {
        const correctedTop = parentScroll + viewportHeight / 2 - iframeTopPosition;
        setModalTop(`${correctedTop}px`);
      }
    } else {
      // Nie jesteśmy w iframe
      setModalTop("50vh");
    }
  };

  return { modalTop };
};